import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import Marquee from '@/components/Marquee';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const CasinoLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="min-h-screen bg-primary">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />
      <Marquee type="mobile" />
      <div className="flex xl:mt-1 min-h-[calc(100vh-169px)]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CasinoLayout;
